/**
 * @generated SignedSource<<f45b0c2d0a291f8b20888a38ea5566d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentManageRealmData$data = {
  readonly ancestors: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly path: string;
  }>;
  readonly blocks: ReadonlyArray<{
    readonly editMode: boolean | null | undefined;
    readonly id: string;
  }>;
  readonly isMainRoot: boolean;
  readonly name: string | null | undefined;
  readonly path: string;
  readonly " $fragmentSpreads": FragmentRefs<"AddButtonsRealmData" | "BlockRealmData">;
  readonly " $fragmentType": "ContentManageRealmData";
};
export type ContentManageRealmData$key = {
  readonly " $data"?: ContentManageRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentManageRealmData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentManageRealmData",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMainRoot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Realm",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlockRealmData"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddButtonsRealmData"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editMode",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Realm",
  "abstractKey": null
};
})();

(node as any).hash = "0b2fb682d33c5ff0288941184e54f1cf";

export default node;
